<template>
  <button
    :type="btnType"
    :class="buttonClass"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>
  
  <script>
export default {
  props: {
    btnType: {
      type: String,
      default: "button",
    },
    type: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    Class: { type: String },
  },
  emits: ["click"],
  computed: {
    buttonClass() {
      return {
        btn: true,
        "btn-primary": this.type === "primary",
        "btn-secondary": this.type === "secondary",
        "btn-danger": this.type === "danger",
        "btn-disabled": this.disabled,
      };
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
};
</script>
  
  <style scoped>
.btn {
  font-family: var(--font-family);
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  box-shadow: 0 2px 4px 0 #0000000a;
  width: 100%;
  line-height: 21px;
  letter-spacing: 0%;
}

.btn-primary {
  background: var(--btn-primary-color);
  color: var(--white);
}

.btn-primary:hover{
  background-color: var(--light-primary);
  color: var(--light-gray);
}

.btn-secondary {
  width: max-content;
  background: #ffffff;
  color: var(--dark-gray);
  border: 1px solid #E5E5EF;
  box-shadow: 0 2px 2px 0 #0000000D;
}

.btn-secondary:hover{
  background-color: var(--light-gray3);
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-disabled {
  background: #ccc;
  color: #666;
  cursor: not-allowed;
}
</style>